import React from 'react'
import { Text } from 'marketing-site/src/library/elements/Text'
import { ISecondaryLinks } from 'marketing-site/src/library/components/Footer'
import stylesFooter from 'marketing-site/src/mvp/library/components/Footer/styles.scss'

export const FooterSecondaryLinks = (secondaryLink: ISecondaryLinks): React.ReactElement => {
  return (
    <>
      {secondaryLink && (
        <li className="secondary-links__list-item" data-testid="secondary-links-list-item">
          <a href={secondaryLink.url} className="secondary-links__link">
            <Text size="body">{secondaryLink.text}</Text>
          </a>
        </li>
      )}
      <style jsx>{stylesFooter}</style>

      <style jsx>{`
        .secondary-links__link :global(span) {
          color: var(--mvp-slate);
        }
      `}</style>
    </>
  )
}
